export const KEYS = {
  // API
  accept: "Accept",
  contentType: "Content-Type",
  redirectTo: "redirectTo",
  token: "token",
  user: "user",
  keepConnected: "keepConnected",
}
